export const FETCH_NOTIFICACIONES_REQUEST = "FETCH_NOTIFICACIONES_REQUEST";
export const FETCH_NOTIFICACIONES_SUCCESS = "FETCH_NOTIFICACIONES_SUCCESS";
export const FETCH_NOTIFICACIONES_FAILURE = "FETCH_NOTIFICACIONES_FAILURE";
